<template>
    <v-container fluid class="b-container">
        <v-sheet class="pa-3">
            <v-toolbar flat>
                <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.create[lang]"
                    @click="dialog = true"
                ></v-btn>

                <v-spacer></v-spacer>

                <v-btn
                    color="secondary"
                    class="text-capitalize px-5"
                    depressed
                    v-text="translations.analiticalReport[lang]"
                    @click="analiticsDialog = true"
                ></v-btn>
            </v-toolbar>

            <v-toolbar flat>
                <v-spacer></v-spacer>
                <v-col cols="12" sm="4" class="pa-0">
                    <b-search-field v-model="search"></b-search-field>
                </v-col>
            </v-toolbar>

            <b-data-table
                :headers="headers"
                :items="multipleCoupons"
                :page.sync="page"   
                @page-sync="p=>page=p"
            >
            <template v-slot:item.gift_title="{ item }">
                    <span class="b-signin-link is-link"
                    @click="setCoupon(item)"
            > <span
                                class="font-weight-bold px-1"
                            >{{ item.gift_title }}</span>
                            </span>
            </template>
                <template v-slot:item.gift_description="{ item }">
                    {{ truncate(item.gift_description) }}
                </template>
            </b-data-table>

            <v-dialog v-model="dialog" max-width="500">
                <CreateForm @cancel="dialog = false" />
            </v-dialog>

            <v-dialog v-model="analiticsDialog" max-width="420">
                <AnaliticalReportForm @cancel="analiticsDialog = false" />
            </v-dialog>
        </v-sheet>
    </v-container>
</template>

<script>
import { mdiMicrosoftExcel, mdiClose } from "@mdi/js";
import debounce from "lodash/debounce";
import CreateForm from "@/components/loyaltyPanel/multipleCoupons/CreateForm";
import AnaliticalReportForm from "@/components/loyaltyPanel/multipleCoupons/AnaliticalReportForm";
import translations from "@/utils/translations/loyaltyPanel/multipleCoupons";
import { mapState, mapMutations, mapActions } from "vuex";

export default {
    name: "MultipleCoupons",

    components: { CreateForm, AnaliticalReportForm },

    mixins: [translations],

    data() {
        return {
            icons: { mdiMicrosoftExcel, mdiClose },
            itemsPerPageOptions: [10, 20, 30, -1],
            analiticsDialog: false,
            page: +this.$route.query.page,
            search: "",
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage", "serverItemsLength"]),
        ...mapState("loyaltyPanel/multipleCoupons", ["multipleCoupons","multipleCoupon"]),

        lang() {
            return this.$route.params.lang;
        },

        dialog: {
            get() {
                return this.$store.state.dialog;
            },

            set(val) {
                this.setDialog(val);
            },
        },

        headers() {
            return [
                {
                    text: this.translations.giftTitle[this.lang],
                    value: "gift_title",
                },
                {
                    text: this.translations.giftDescription[this.lang],
                    value: "gift_description",
                    width: 200,
                },
                {
                    text: this.translations.masterCode[this.lang],
                    value: "code",
                },
                {
                    text: this.translations.price[this.lang],
                    value: "price",
                },
                {
                    text: this.translations.maximum[this.lang],
                    value: "maximum",
                },
                {
                    text: this.translations.validityPeriod[this.lang],
                    value: "expiration_date",
                },
            ];
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
    },

    methods: {
        ...mapActions("loyaltyPanel/multipleCoupons", ["getItems"]),
        ...mapMutations("loyaltyPanel/multipleCoupons", ["setMultipleCoupon"]),
        ...mapMutations(["setDialog"]),

        handleSearch() {
            this.getItems(`?q=${this.search}`);
        },

        truncate(input) {
            if (input) {
                if (input.length > 20) {
                    return input.substring(0, 20) + "...";
                }
                return input;
            }
        },
        
        setCoupon(data){
            this.setMultipleCoupon(data)
            this.$router.push({ name: 'MultipleCouponsClaims', params: { coupon_id: data.coupon_id }})
        }
    },

    mounted() {
        this.getItems(this.query);
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.push({
                    query: {
                        page: 1,
                        ...this.$route.query,
                    },
                });
            }
            this.getItems(this.query);
        },

        page(page) {
            this.$router.push({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getItems(this.query);
            } else {
                this.debouncedSearch();
            }
        },
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.push({
                query: {
                    page: 1,
                    ...this.$route.query,
                },
            });
        }
    },
};
</script>

<style scoped>
.b-outlined {
    border: 1px solid rgba(0, 0, 0, 0.12);
}

.navLink {
    text-decoration: none;
}

.navLink:hover {
    text-decoration: underline;
}

.is-link{
    color: blue;
    cursor: pointer;
    text-decoration: underline;
}
</style>
